[
  {
    "path": "/",
    "title": "Global Cart Kit",
    "description": "Everything you need to sell globally with confidence. Currency conversion, IP geolocation, holiday calendars, IBAN validation, HS codes, and more.",
    "changefreq": "daily",
    "priority": "1.0"
  },
  {
    "path": "/currency",
    "title": "Currency Converter - Global Cart Kit",
    "description": "Live currency conversion powered by ECB/Frankfurter data. No API key required.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/geolocation",
    "title": "IP Geolocation - Global Cart Kit",
    "description": "Look up the geographic location of any IP address in real time.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/holidays",
    "title": "Holiday Calendar - Global Cart Kit",
    "description": "Public holiday calendars for 100+ countries, powered by Nager.Date.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/hs-code",
    "title": "HS Code Search - Global Cart Kit",
    "description": "Search the WCO HS 2022 dataset of 5,000+ harmonized system codes.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/iban",
    "title": "IBAN Validator - Global Cart Kit",
    "description": "Validate IBAN numbers across all 77 ISO 13616 countries, client-side.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/unit-converter",
    "title": "Unit Converter - Global Cart Kit",
    "description": "Convert between metric, imperial, and trade units for global shipping.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/timezone",
    "title": "Timezone Converter - Global Cart Kit",
    "description": "Convert times across world timezones for international scheduling.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/language-locale",
    "title": "Language & Locale - Global Cart Kit",
    "description": "Browse language codes, locale identifiers, and regional settings by country.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/vat-calculator",
    "title": "VAT / GST Calculator - Global Cart Kit",
    "description": "Calculate VAT and GST for 60+ countries with correct local tax names.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/phone-number-generator",
    "title": "Phone Number Format Guide & Generator - Global Cart Kit",
    "description": "Phone number formats for 245 countries, with format-valid dummy mobile numbers for testing checkout forms.",
    "changefreq": "monthly",
    "priority": "0.8"
  },
  {
    "path": "/trade-trends",
    "title": "Global Trade Trends - Global Cart Kit",
    "description": "Track commodity price trends - oil, gas, and metals - for global sourcing and trade decisions.",
    "changefreq": "weekly",
    "priority": "0.9"
  },
  {
    "path": "/shipping-calculator",
    "title": "Shipping Calculator - Global Cart Kit",
    "description": "A worldwide shipping-cost estimator is on the roadmap and coming soon.",
    "changefreq": "monthly",
    "priority": "0.3"
  },
  {
    "path": "/news",
    "title": "News & Insights - Global Cart Kit",
    "description": "Stay ahead of global commerce with expert analysis, regulatory updates, and market intelligence.",
    "changefreq": "daily",
    "priority": "0.8"
  },
  {
    "path": "/news/topic/ai-commerce",
    "title": "AI & Commerce - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on AI & Commerce for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/news/topic/vat-tax",
    "title": "VAT & Tax - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on VAT & Tax for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/news/topic/payments",
    "title": "Payments - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on Payments for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/news/topic/logistics-shipping",
    "title": "Logistics & Shipping - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on Logistics & Shipping for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/news/topic/marketplaces",
    "title": "Marketplaces - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on Marketplaces for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/news/topic/localization",
    "title": "Localization - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on Localization for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/news/topic/cross-border",
    "title": "Cross-Border Trade - Commerce Intelligence - Global Cart Kit",
    "description": "Expert analysis and market alerts on Cross-Border Trade for global e-commerce operators.",
    "changefreq": "daily",
    "priority": "0.7"
  },
  {
    "path": "/resources",
    "title": "Resources - Global Cart Kit",
    "description": "Data sources, methodology, tool guides, and developer notes for Global Cart Kit.",
    "changefreq": "monthly",
    "priority": "0.7"
  },
  {
    "path": "/about",
    "title": "About - Global Cart Kit",
    "description": "What Global Cart Kit is, who it's for, and how data honesty works.",
    "changefreq": "monthly",
    "priority": "0.6"
  },
  {
    "path": "/privacy",
    "title": "Privacy Policy - Global Cart Kit",
    "description": "How Global Cart Kit collects, uses, and protects your data.",
    "changefreq": "yearly",
    "priority": "0.4"
  },
  {
    "path": "/terms",
    "title": "Terms of Service - Global Cart Kit",
    "description": "The terms governing use of Global Cart Kit's tools and services.",
    "changefreq": "yearly",
    "priority": "0.4"
  }
]
